module.exports = __webpack_public_path__ + "static/media/15.f7e4b623.JPG";